import { requestApi } from 'api/Api';

export const getCdtCodes = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/get', navigate, params });

export const getCdtWithSpecialties = async (navigate, params) =>
  requestApi({ url: '/api/codes/cdt/get_with_specialties', navigate, params });
